import { ElectronTsdownError } from './ElectronTsdownError.js'

export class ConfigError extends ElectronTsdownError {}
